import "./App.css";
import { Route, Routes } from "react-router-dom";
import Layout from "./component/Layout1";
import Dashbaord from "./page/dashboard";
import ManageUser from "./page/manage-user";
import UserEdit from "./page/user-edit";
import Setting from "./page/setting";
import {
  LoginProtectedRoute,
  ProtectedRoute,
} from "./component/Route/protectedRoute";
import Login from "./component/Login/login";
import Translation from "./page/translation";
import Restore from "./page/restore-user";
import Patrika from "./page/patrika";
import Notification from "./page/notification";
import Quotes from "./page/quotes";

const getAccessToken = () => {
  return localStorage.getItem("token");
};

function App() {
  return (
    <>
      <Routes>
        <Route
          element={
            <LoginProtectedRoute>
              <Login />
            </LoginProtectedRoute>
          }
          path="/sign-in"
        />

        <Route path="/" element={<Layout />}>
          <Route
            element={
              <ProtectedRoute isAuthenticated={!!getAccessToken()}>
                <Dashbaord />
              </ProtectedRoute>
            }
            path="/"
          />
          {/* <Route path="/" element={<Dashbaord />} /> */}

          <Route
            element={
              <ProtectedRoute isAuthenticated={!!getAccessToken()}>
                <ManageUser />
              </ProtectedRoute>
            }
            path="/manage-user"
          />
          {/* <Route path="/manage-user" element={<ManageUser />} /> */}

          <Route
            element={
              <ProtectedRoute isAuthenticated={!!getAccessToken()}>
                <UserEdit />
              </ProtectedRoute>
            }
            path="/user-edit/:userId"
          />
          {/* <Route path="/user-edit" element={<UserEdit />} /> */}

          <Route
            element={
              <ProtectedRoute isAuthenticated={!!getAccessToken}>
                <Setting />
              </ProtectedRoute>
            }
            path="/setting"
          />
        </Route>
        <Route
          element={
            <ProtectedRoute isAuthenticated={!!getAccessToken}>
              <Translation />
            </ProtectedRoute>
          }
          path="/translation"
        />
        <Route
          element={
            <ProtectedRoute isAuthenticated={!!getAccessToken}>
              <Restore />
            </ProtectedRoute>
          }
          path="/restore-user"
        />
        <Route
          element={
            <ProtectedRoute isAuthenticated={!!getAccessToken}>
              <Patrika />
            </ProtectedRoute>
          }
          path="/patrika"
        />
        <Route
          element={
            <ProtectedRoute isAuthenticated={!!getAccessToken}>
              <Notification />
            </ProtectedRoute>
          }
          path="/notification"
        />
        <Route
          element={
            <ProtectedRoute isAuthenticated={!!getAccessToken}>
              <Quotes />
            </ProtectedRoute>
          }
          path="/quotes"
        />
      </Routes>
    </>
  );
}

export default App;
